// extracted by mini-css-extract-plugin
module.exports = {"section":"styles__section___3v1E5","sectionClip":"styles__sectionClip___2os5N","sectionHeader":"styles__sectionHeader___3ajmX"};